export default "__VITE_ASSET__DSdprNL5__"